import { render, staticRenderFns } from "./soil.vue?vue&type=template&id=22c87438&scoped=true&"
import script from "./soil.vue?vue&type=script&lang=js&"
export * from "./soil.vue?vue&type=script&lang=js&"
import style0 from "./soil.vue?vue&type=style&index=0&id=22c87438&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c87438",
  null
  
)

export default component.exports